module.exports = __webpack_public_path__ + "static/2-d71f50006469d84385ff30adf99c2ce4.png";